<template>
  <div>
    <div class="fileInput">
      <input accept=".xlsx, .xls" type="file" style="display:none;" id="upload" ref="upload" @change="upExHandler" value="点击导入"/>
      <label for="upload">点击上传文件</label>
      <div>{{this.fileName}}</div>
      <div v-if="errorEx">导入失败.请点击<a :href="errorEx" style="text-decoration:underline; color:#409EFF; padding:0 10px;">下载</a>查看失败原因</div>
    </div>
    <div class="footer">
      <a :href="demoExcel" style="font-size:14px; margin-right:20px; text-decoration:underline;" download="demo">下载模板</a>
      <el-button type="primary" @click="submitUpload">确定导入</el-button>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
export default {
  props: {
    upApi: String,
    needAtrID: Boolean,
    atrID: String,
    demoExcel: String
  },
  data() {
    return {
      loading: false,
      fileName: '',
      errorEx: '',
      files: {}
    }
  },
  methods: {
    upExHandler () {
      this.files = this.$refs.upload.files[0]
      const extension = this.$refs.upload.files[0].name.split('.')[1] === 'xls'
      const extension2 = this.$refs.upload.files[0].name.split('.')[1] === 'xlsx'
      const isLt2M = this.$refs.upload.files[0].size / 1024 / 1024 < 2
      if (!extension && !extension2) {
        alert('上传文件只能是 xls、xlsx格式!')
        return
      }
      if (!isLt2M) {
        alert('上传文件大小不能超过 2MB!')
        return
      }
      this.fileName = this.$refs.upload.files[0].name
    },
    submitUpload () { // 确认上传
      if (this.needAtrID && !this.atrID) { // 如果需要展商id
        this.$alert('请选择展商')
        return false
      }
      if (this.fileName === '') {
        this.$alert('请选择要上传的文件！')
        return false
      }
      const fileFormData = new FormData()
      fileFormData.append('files', this.files)
      const instance = axios.create({
        withCredentials: true
      })
      let apiUrl = ''
      if (this.needAtrID){
        apiUrl = `${this.upApi}&atrID=${this.atrID}`
      } else {
        apiUrl = this.upApi
      }
      instance.post(apiUrl, fileFormData, { headers: { token: localStorage.getItem('token'), 'Content-Type': 'multipart/form-data' } })
        .then(response => {
          if (response.data.code === 200) {
            this.errorEx = response.data.data
            this.$refs.upload.value = ''
            this.fileName = ''
            if (response.data.msg.indexOf('导入成功')!==-1) {
              this.$message({
                type: 'success',
                message: response.data.msg
              });
              if(response.data.data == ''){
                this.$emit('drToggle', false)
              }else{
                 this.$emit('drToggle', true)
              }
              
            }
          } else {
            this.$message({
              type: 'error',
              message: response.data.msg
            });
          }
        })
        .catch((error) => {
          console.log(error)
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.fileInput{
  line-height: 36px;
  text-align: center;
  label{
    font-size: 14px;
    background: #409EFF;
    color:#fff;
    border-radius: 6px;
    font-weight: normal;
    padding: 0px 12px;
    height: 36px;
    line-height: 36px;
    display: inline-block;
    padding-right: 20px;
  }
}
.footer{
  text-align: center;
  padding: 40px 0 10px;
}
</style>
